import React from 'react';
import CommandeSingle from '../CommandeSingle/CommandeSingle';
import { FeatureContainer } from '../../components/molecules/Containers/FeatureContainer';
import useStyle from './AFinaliser.style';

const OutForDelivery = ({ commande }) => {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <FeatureContainer>
        <div className={classes.content}>
          <h2>
            Vous ne pouvez pas éditer une commande ayant une expédition en cours{' '}
            <span role="img" aria-label="emoji déçu">
              😕
            </span>
          </h2>
          <p>Veuillez contacter France-Challenges pour la modifier</p>
        </div>
      </FeatureContainer>
      <CommandeSingle commande={commande} />
    </div>
  );
};
export default OutForDelivery;
